export default __webpack_public_path__ + "static/fingerprint-hero-813acbb81fd6fb00a2093e10f7f7158a.jpeg";